import { SkippedProsPersistence } from './skipped-pros.persistence';
import { useSearchStore } from '../search/search.store';
import { SnackbarService } from '@/core/shared/snackbar/snackbar.service';
import { MessagingService } from '../messaging/messaging.service';

export class SkippedProsService {
  private persistence = new SkippedProsPersistence();
  private store = useSearchStore();
  private messagingService = new MessagingService();

  private async updateSkipStatus(
    proProfileId: number,
    skipped: boolean,
    executeOperation: () => Promise<void>,
    errorMessage: string,
  ): Promise<boolean> {
    const candidate = this.store.candidates.find((c) => Number(c.profileId) === proProfileId);
    if (!candidate) return false;

    const originalStatus = candidate.skipped;
    candidate.skipped = skipped;

    try {
      await executeOperation();
      return true;
    } catch {
      candidate.skipped = originalStatus;
      SnackbarService.critical(errorMessage);
      return false;
    }
  }

  async skipPro(proProfileId: number): Promise<void> {
    this.messagingService.removeProFromSelectedUserProfiles(proProfileId);

    const success = await this.updateSkipStatus(
      proProfileId,
      true,
      () => this.persistence.skipPro(proProfileId),
      'Failed to skip candidate. Please try again.',
    );

    if (!success) return;

    SnackbarService.showSnackbar({
      text: 'Candidate skipped.',
      variant: 'success',
      timeout: 5000,
      showUndo: true,
      undoAction: () => this.restorePro(proProfileId),
    });
  }

  async restorePro(proProfileId: number): Promise<void> {
    await this.updateSkipStatus(
      proProfileId,
      false,
      () => this.persistence.restorePro(proProfileId),
      'Failed to restore candidate. Please try again.',
    );
  }
}
